import request from '@/utils/request'

/**
 * 运输异常
 */
export function getTransportAbnormalList(query) {
  return request({
    url: '/ntocc-basic-api/transportAbnormal',
    method: 'get',
    params: query
  })
}
export function getTransportAbnormalDetail(code) {
  return request({
    url: `/ntocc-basic-api/transportAbnormal/${code}`,
    method: 'get'
  })
}
export function batchRead(query) {
  return request({
    url: `/ntocc-basic-api/transportAbnormal/batchRead`,
    method: 'post',
    params: query
  })
}
export function fetchList(query) {
  return request({
    url: '/ntocc-basic-api/orderComment/report',
    method: 'get',
    params: query
  })
}
// 评价管理列表
export function evaluationManagement(query) {
  return request({
    url: '/ntocc-basic-api/orderComment/evaluationManagement',
    method: 'get',
    params: query
  })
}
// 评价管理设置
export function updateEvaluationManagementConfig(query) {
  return request({
    url: `/ntocc-basic-api/partyGroupConfig/updateEvaluationManagementConfig`,
    method: 'put',
    params: query
  })
}
// 获取评价管理设置
export function getEvaluationManagementConfig(query) {
  return request({
    url: `/ntocc-basic-api/partyGroupConfig/getEvaluationManagementConfig`,
    method: 'put',
    params: query
  })
}
// 评价管理冻结
export function freezeParty(query) {
  return request({
    url: `/ntocc-basic-api/party/freezeParty`,
    method: 'post',
    params: query
  })
}
// 消息推送
export function pushEvaluationManagement(query) {
  return request({
    url: `/ntocc-basic-api/orderComment/pushEvaluationManagement`,
    method: 'post',
    params: query
  })
}
export function shipmentReport(query) {
  return request({
    url: '/ntocc-basic-api/orderComment/shipmentReport',
    method: 'get',
    params: query
  })
}
export function evaluateList(query) {
  return request({
    url: '/ntocc-basic-api/orderComment',
    method: 'get',
    params: query
  })
}
export function feedbackList(query) {
  return request({
    url: '/ntocc-basic-api/feedback',
    method: 'get',
    params: query
  })
}
export function EditOriginalGoods(data) {
  return request({
    url: '/ntocc-tms-api/orderDetail/detailPaperReturns',
    method: 'put',
    params: data
  })
}
export function payAdvance(data) {
  return request({
    url: '/ntocc-tms-api/payAdvance',
    method: 'post',
    data
  })
}
export function payAdvanceOilCard(data) {
  return request({
    url: '/ntocc-tms-api/payAdvance/oilCard',
    method: 'post',
    params: data
  })
}
export function payAdvanceYuList(query) {
  return request({
    url: '/ntocc-tms-api/payAdvance',
    method: 'get',
    params: query
  })
}
// 更新状态
export function queryShipperPrepaidResult(query) {
  return request({
    url: '/ntocc-tms-api/arpaTransfer/queryShipperPrepaidResult',
    method: 'post',
    params: query
  })
}
